import BaseModelAPI from '../BaseModelAPI';

export default class ScrapExecutionDetail extends BaseModelAPI {
	static entity = 'scrapexecutiondetail';
	static entityName = 'scrapexecutiondetail';

	constructor() {

		/*APP_MODEL_DEFINITION*/
		this.id = '';
		this.scrapExecutionId = '';
		this.scrapExecution = {};
		this.controlCardId = '';
		this.controlCard = {};
		this.partId = '';
		this.part = {};
		this.partName = '';
		this.caseQty = 0;
		this.isScrap = false;
		this.fileEvidenceId = '';
		this.fileEvidence = {};
		this.isFromUpload = false;
		this.isSavedToBackend = true;
		this.uploadValidationMessage = '';
		this.uploadValidationStatus = '';
		/*END_APP_MODEL_DEFINITION*/
	}

	static async generateData(this_, parentId, customerId) {
		return this_.$http.put(`${this.entityName}/generatedata/${parentId}`, customerId)
			.then(result => {
				return result.data;
			}).catch(function (error) {
				this_.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
	}
}